import { VIEW_OFFER_DETAIL_CART_ID_KEY } from '@components/PersonalizedOffer/hooks/useGenerateViewOfferDetailLink';

export const getCartIdParam = () => {
  const queryString = window.location.search;
  const urlSearchParams = new URLSearchParams(queryString);

  return urlSearchParams.get(VIEW_OFFER_DETAIL_CART_ID_KEY) || '';
};
